import API from "../utils/api";


export const getLogsApi = async filters => {
    const response = await API.get('log/get-logs', { params: filters });
    return { response };
};